<template>
  <div>
    <div class="d-flex justify-space-around ">
      <v-card :outlined="true" class="list">
        <v-list>
          <v-subheader>Необходимо изучить</v-subheader>
          <v-list-item-group color="primary">
            <v-list-item
                    v-for="(item, i) in filteredUsed"
                    @click="toUnused(item.idx)"
                    @mouseenter="showArrowRight = i"
                    @mouseleave="showArrowRight = false"
                    :key="item.idx"
            >
              <v-list-item-content>
                <v-list-item-title
                        v-text="$store.getters.conceptInTitle(item.concept)"
                />
              </v-list-item-content>
              <v-list-item-icon v-if="showArrowRight === i">
                <v-icon>mdi-arrow-right</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
      <v-card :outlined="true" class="list">
        <v-list>
          <v-subheader>Я уже это знаю</v-subheader>
          <v-list-item-group color="primary">
            <v-list-item
                    v-for="(item, i) in filteredUnused"
                    @click="toUsed(item.idx)"
                    @mouseenter="showArrowLeft = i"
                    @mouseleave="showArrowLeft = false"
                    :key="item.idx"
            >
              <v-list-item-icon v-if="showArrowLeft === i">
                <v-icon>mdi-arrow-left</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                        class="text-end"
                        v-text="$store.getters.conceptInTitle(item.concept)"
                />
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </div>
    <div class="d-flex justify-center ma-3">
      <v-btn
              v-if="onPrevStep"
              @click="onPrevStep"
              text
      >
        Назад
      </v-btn>
      <v-btn
              v-if="onNextStep"
              @click="() => onNextStep(convertUsed())"
              text
      >
        {{'Получить план'}}
      </v-btn>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PlanModifier",
    props: {
      used: {
        type: Array,
        default: () => ['HTML', 'CSS', 'JavaScript', 'React.js']
      },
      unused: {
        type: Array,
        default: () => [null, null, null, null]
      },
      onNextStep: Function,
      onPrevStep: Function,
    },
    data() {
      return {
        showArrowRight: false,
        showArrowLeft: false,
      }
    },
    computed: {
      filteredUsed() { return this.used.filter(item => item.concept !== null); },
      filteredUnused() { return this.unused.filter(item => item.concept !== null); }
    },
    methods: {
      toUnused(idx) {
        this.unused[idx].concept = this.used[idx].concept;
        this.used[idx].concept = null;
        this.showArrowRight = false;
      },
      toUsed(idx) {
        this.used[idx].concept = this.unused[idx].concept;
        this.unused[idx].concept = null;
        this.showArrowLeft = false;
      },
      convertUsed() {
        return this.filteredUsed.map(item => item.concept);
      }
    }
  }
</script>

<style scoped>
  .list {
    width: 40%
  }
</style>
